import { render } from "./AddVacancyDepartmentType.vue?vue&type=template&id=5a7563cb"
import script from "./AddVacancyDepartmentType.vue?vue&type=script&lang=js"
export * from "./AddVacancyDepartmentType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__